import React from "react";
import "./com_2.css";

const CimSection = () => {
  return (
    <div className="cim-section">
      <div className="cim-container">
        <div className="cim-card">
          <h2>Providing accurate and insightful astrological readings</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur. Adipiscing sodales cras dictum
            enim sit neque enim enim. Integer semper pretium felis libero magna a
            ipsum vivamus vitae. Pulvinar dolor nibh tortor ornare nullam risus mi.
          </p>
        </div>
        <div className="cim-card">
          <h2>Delivering timely and reliable guidance for your daily life</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur. Adipiscing sodales cras dictum
            enim sit neque enim enim. Integer semper pretium felis libero magna a
            ipsum vivamus vitae. Pulvinar dolor nibh tortor ornare nullam risus mi.
          </p>
        </div>
        <div className="cim-card">
          <h2>Continuously learning and growing in the field of astrology</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur. Adipiscing sodales cras dictum
            enim sit neque enim enim. Integer semper pretium felis libero magna a
            ipsum vivamus vitae. Pulvinar dolor nibh tortor ornare nullam risus mi.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CimSection;
